import { render, staticRenderFns } from "./FormAddTO.vue?vue&type=template&id=70ab8160"
import script from "./FormAddTO.vue?vue&type=script&lang=js"
export * from "./FormAddTO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports